import Cookies from "universal-cookie";
import { cryptoStorage } from "./crypto";

const options = { path: "/", sameSite: "lax", secure: window.location.protocol === "https:" };

export function clearRememberedSession() {
  new Cookies().remove("session", options);
}

export function rememberSession(user) {
  if (!user.rememberMe || !user.refreshToken) {
    clearRememberedSession();
    return;
  }
  const token = cryptoStorage.encrypt(user.refreshToken);
  if (token) new Cookies().set("session", token, { ...options, maxAge: 60 * 60 * 24 * 30 });
}

export function readRememberedSession() {
  const encrypted = new Cookies().get("session");
  if (!encrypted) return null;
  const token = cryptoStorage.decrypt(encrypted);
  if (!token) clearRememberedSession();
  return token || null;
}
